import { render } from "./NoticiasView.vue?vue&type=template&id=4d8c5eab&scoped=true"
import script from "./NoticiasView.vue?vue&type=script&lang=js"
export * from "./NoticiasView.vue?vue&type=script&lang=js"

import "./NoticiasView.vue?vue&type=style&index=0&id=4d8c5eab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d8c5eab"]])

export default __exports__